import * as PIXI from "pixi.js";
import heartImage from "../assets/heart.png";
import { charaSize } from "../constants";
import { CollisionManager, createRect } from "../managers/collisionManager";
import { HeartManager } from "../managers/heartManager";
import { LoadManager } from "../managers/loadManager";
import { SoundManager } from "../managers/soundManager";

export function loadHeartAssets(loadManager: LoadManager) {
  return {
    heart: loadManager.loadTexture(heartImage),
  } as const;
}

export type SetupHeartProps = Readonly<{
  heartAssets: ReturnType<typeof loadHeartAssets>;
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  collisionManager: CollisionManager;
  soundManager: SoundManager;
  heartManager: HeartManager;
  x: number;
  y: number;
}>;

export function setupHeart({
  heartAssets,
  parent,
  ticker,
  collisionManager,
  soundManager,
  heartManager,
  x,
  y,
}: SetupHeartProps) {
  const heart = new PIXI.Sprite(heartAssets.heart.get());
  heart.width = charaSize;
  heart.height = charaSize;
  heart.x = x;
  heart.y = y;
  heart.anchor.set(0.5, 0.5);

  const rect = createRect(
    "heart",
    x - charaSize / 2,
    y - charaSize / 2,
    charaSize,
    charaSize,
  );

  parent.addChild(heart);
  const onTick = () => {
    const collides = collisionManager.check(rect);
    if (collides.some((c) => c.type === "player")) {
      parent.removeChild(heart);
      ticker.remove(onTick);
      soundManager.playPowerupSE();
      heartManager.get();
    }
  };

  ticker.add(onTick);

  const dispose = () => {
    parent.removeChild(heart);
    ticker.remove(onTick);
  };

  return dispose;
}
